<template>
  <category-form ref="categoryForm" v-if="category.data" :category="category.data"></category-form>
</template>

<script>
import categoryForm from "./Form";

export default {
  components: {
    categoryForm
  },

  data() {
    return {
      category: new window.RemoteData(
        () => `/admin/api/magazine/categories/${this.$route.params.id}`
      ).load()
    };
  }
};
</script>
